<template>
  <div class="plaform flex">
    <div class=" flex" @click="$router.replace('/user')">
      <img src="../../../static/logo.png" alt="">
      <span>知视猫</span>
    </div>
    <div class="line" />
    <div v-if="$store.state['zsm-user'].douyinPlatFormDict!='douyin'" class="plaformNo flex" @click="changePlatformCode('douyin','douyin')">
      <img src="../../../static/douyin.png" alt="知视猫">
      <span>抖音</span>
    </div>

    <div v-else class="plaformNo flex" @click="changePlatformCode('douyin','douyin')">
      <img src="../../../static/douyinS.png" alt="知视猫">
      <span style="color: #FF4D6D;">抖音</span>
    </div>

    <div class="line" />
    <div v-if="$store.state['zsm-user'].douyinPlatFormDict=='doudian'" class="plaformNo flex" @click="changePlatformCode('douyin','doudian')">
      <img src="../../../static/doudianS.png" alt="知视猫">
      <span style="color: #2a55e5;">抖店</span>
    </div>
    <div v-else class="plaformNo flex" @click="changePlatformCode('douyin','doudian')">
      <img src="../../../static/doudian.png" alt="知视猫">
      <span>抖店</span>
    </div>

    <div class="line" />
    <div v-show="$store.state['zsm-user'].platformDict=='kuaishou'" class="plaformNo flex" @click="changePlatformCode('kuaishou','kuaishou')">
      <img src="../../../static/kuaishou2.png" alt="知视猫">
      <span style="color: #ff4906;">快手</span>
    </div>

    <div v-show="$store.state['zsm-user'].platformDict!=='kuaishou'" class="plaformNo flex" @click="changePlatformCode('kuaishou','kuaishou')">
      <img src="../../../static/kuaishou.png" alt="知视猫">
      <span>快手</span>
    </div>

    <div class="line" />
    <div v-show="$store.state['zsm-user'].douyinPlatFormDict=='shipinhao'" class="plaformNo flex" @click="changePlatformCode('shipinhao','shipinhao')">
      <img style="width: 22px;" src="../../../static/weixin2.png" alt="知视猫">
      <span style="color:#13ce66;">微信</span>
    </div>

   <div v-show="$store.state['zsm-user'].douyinPlatFormDict!=='shipinhao'" class="plaformNo flex" @click="changePlatformCode('shipinhao','shipinhao')">
      <img style="width: 22px;" src="../../../static/weixinS.png" alt="知视猫">
      <span>微信</span>
    </div>


      <div class="line" />
    <div v-show="$store.state['zsm-user'].douyinPlatFormDict=='xiaohongshu'" class="plaformNo flex" @click="changePlatformCode('shipinhao','xiaohongshu')">
      <img style="width: 22px;" src="../../../static/xiaohongshu.png" alt="知视猫">
      <span class="xiaohongshu">小红书</span>
    </div> 

     <div v-show="$store.state['zsm-user'].douyinPlatFormDict!=='xiaohongshu'" class="plaformNo flex" @click="changePlatformCode('shipinhao','xiaohongshu')">
      <img style="width: 22px;" src="../../../static/xiaohongshuS.png" alt="知视猫">
      <span>小红书</span>
    </div>

  </div>
</template>

<script>
import { getLocalStorage, saveLocalStorageString } from '@/utils/auth'

export default {
  name: 'Index',
  data() {
    return {

    }
  },
  computed: {
    platformDict() {
      return this.$store.state['zsm-user'].platformDict
    },
     douyinPlatFormDict() {
      return this.$store.state['zsm-user'].douyinPlatFormDict
    },
    userInfo() {
      if (this.$store.state['zsm-user'].userInfo) {
        return JSON.parse(JSON.parse(this.$store.state['zsm-user'].userInfo))
      } else {
        return JSON.parse(JSON.parse(getLocalStorage('zsm-userInfo')))
      }
    }
  },
  watch: {
    douyinPlatFormDict() {
      this.$router.replace('/')

      /* const path = this.$route.path
     const query = this.$route.query

    if (query.id) { // 参数存在
       if (path == '/course/album') { // 修改作品相关时，切换平台跳转页面
         this.$router.replace('/course/list')
       } else if (path == '/serve/add') {
         this.$router.replace('/serve/list')
       } else if (path == '/serve/consult') {
         this.$router.replace('/serve/consult-list')
       } else if (path == '/serve/material') {
         this.$router.replace('/serve/download-list')
       } else {
         location.reload()
       }
     } else {
       location.reload()
     }*/
      // this.$router.replace('/')

      // console.log( this.$route)
      // location.reload()
      // this.$router.replace(this.$route.path)
      // this.$router.go(0)
    }
  },
  mounted() {

  },
  methods: {
    // 切换平台
    changePlatformCode(platformDict, douyinPlatFormDict) {
      this.$store.dispatch('zsm-user/getByMobileAndPlatform', { // 根据手机号和平台查询用户信息
        mobile: this.userInfo.mobile,
        platformDict
      }).then((info) => {
        if (info.result == 'true') {
          this.$store.state['zsm-user'].douyinPlatFormDict = douyinPlatFormDict // 抖音平台类型  抖音/抖店
          this.$store.state['zsm-user'].platformDict = platformDict // 平台类型  抖音/快手
          saveLocalStorageString('douyinPlatFormDict', douyinPlatFormDict) // 抖音平台类型  抖音/抖店
          this.$store.commit('zsm-user/SET_PLATFORM_DICT', platformDict)
        } else {
          this.$confirm('您暂未绑定该平台账号, 是否前往绑定?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (platformDict == 'douyin') {
              this.$router.replace('/account/dyaccount')
            } else if (platformDict == 'kuaishou') {
              this.$router.replace('/account/ksaccount')
            } else if (platformDict == 'shipinhao') {
              this.$router.replace('/account/wxaccount')
            }
          }).catch(() => {

          })

          // this.$message({ message: info.message, type: 'error' })
          // this.$message({ message:'您暂未绑定平台账号，请前往绑定', type: 'error' })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  @import "@/styles/variable-color.scss";
  .plaform{
    padding-left: 10px;
    font-size: 13px;
    font-weight: bold;
    div{
      align-items: center;
    }
    .xiaohongshu{
        color:$color-primary-xiaohongshu!important;
    }
    .line{
      margin: 0 24px;
      width: 1px;
      height: 19px;
      background-color: $white;
    }
    color: $white;
    align-items: center;
    // padding: 0 30px;
        img{
          margin-right: 0px;
          width: 40px;
          height: 40px;
        }
  }
  .plaformNo{
  font-family:-webkit-pictograph;
    img{
      margin-right: 5px;
      width: 20px;
      height: 20px;
    }
  }

</style>
